






































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import PartnerApi from '@/api/partner'
import PageLayout from '../../../components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './orderlist-colums'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'

@Component({
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	public getList() {
		const form = this.getForm()
		form.partnerId = this.$route.params.partnerId
		return PartnerApi.getDailyList(form).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.getList()
	}

	private deactivated() {
		clearInterval(this.timer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.beginTime =
			form.rangeTime &&
			form.rangeTime[0] &&
			form.rangeTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.rangeTime &&
			form.rangeTime[1] &&
			form.rangeTime[1].format('YYYY-MM-DD')
		delete form.rangeTime

		return form
	}

	private canAudit(action: any) {
		return (
			(action.orderStatus === '04' && this.$auth('taskDetail:auditTask')) ||
			(action.orderStatus === '031' && this.$auth('taskDetail:checkTaskInfo'))
		)
	}

	private resend(orderId: string) {
		this.$confirm({
			title: '提示',
			content: '确认重新发送吗 ?',
			onOk: () => {
				return TaskApi.resendOrder(orderId).then((res: any) => {
					this.$message.success('发送成功')
					this.getList()
				})
			},
		})
	}

	private exportList() {
		this.exportingList = true
		const form = this.getForm()
		form.partnerId = this.$route.params.partnerId
		PartnerApi.exportOrderTreadList(form)
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
